var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationBellIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.56 25.3333L23 19.7733V12.3333C23 8.81333 20.3867 5.92 17 5.44V4H15V5.44C11.6133 5.93333 9 8.82667 9 12.3333V19.7733L6.44 25.3333H12.4933C12.9333 26.8667 14.3333 28 16 28C17.6667 28 19.0667 26.8667 19.5067 25.3333H25.56ZM11 20.2267V12.3333C11 9.57333 13.24 7.33333 16 7.33333C18.76 7.33333 21 9.57333 21 12.3333V20.2267L22.44 23.3333H9.56L11 20.2267Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationBellIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Notification_Bell_Icon.16a4bae602a45eff2d48843cae7bef58.svg";